/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>1 - Instant</b>: Моментально всем</li>\n<li><b>2 - AtTime</b>: В указанное время</li>\n</ul>\n
 */
export const notificationConditionTypeEnumSchema = z.union([z.literal(1), z.literal(2)]).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Instant</b>: Моментально всем</li>\n<li><b>2 - AtTime</b>: В указанное время</li>\n</ul>\n")